import { AudiencePanel } from '../broadcasts';
import type { AudienceScope } from '../../types/broadcast';
import type { SurveyLinkMode } from '../../types/survey';
import { SurveyAudienceSummary } from './SurveyAudienceSummary';

// Phase 6B B6/B+ — the compose Audience tab. Reuses the broadcast AudiencePanel
// (selection) + the broadcast-style SurveyAudienceSummary (counts + the shared
// recipient-preview modal). Link-mode phrasing (the per_location note) lives in
// the summary.
export function AudienceTab({
  scope,
  linkMode,
  onChange,
}: {
  scope: AudienceScope;
  linkMode: SurveyLinkMode;
  onChange: (next: AudienceScope) => void;
}) {
  return (
    // max-w-2xl matches the Send tab's reading column so the summary + picker
    // don't sprawl on wide screens (B++). Content tab stays wider by design.
    <div className="max-w-2xl space-y-5">
      <AudiencePanel scope={scope} onChange={onChange} />
      <SurveyAudienceSummary scope={scope} linkMode={linkMode} />
    </div>
  );
}
